import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route (pathname) changes.
 * React Router preserves scroll position by default, which left users
 * mid-page after navigating. In-page state changes (e.g. news pagination)
 * don't change the pathname, so they are unaffected.
 */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default ScrollToTop;
